<template>
  <el-drawer
    :title="title"
    :visible="show"
    class="dialogPopRule"
    destroy-on-close
    size="960px"
    @close="handleClose"
  >
    <add-and-edit
      v-if="mode==='ADD' || mode==='EDIT'"
      :current="current"
      :visible="show"
      @close="handleClose"
    />
    <Subscribe v-else-if="mode==='SUBSCRIBE'" :current="current" />
    <cat-details
      v-else
      :current="current"
      :cat-user="catUser"
    />
  </el-drawer>
</template>

<script>
import CatDetails from './CatDetails.vue';
import AddAndEdit from './AddAndEdit.vue';
import Subscribe from './Subscribe.vue';

export default {
  name: 'FormDialog',
  components: {
    CatDetails,
    AddAndEdit,
    Subscribe,
  },
  props: {
    mode: {
      type: String,
      default: 'ADD', // 'ADD' | 'EDIT' | 'DETAILS'
    },
    visible: {
      type: Boolean,
      default: false,
    },
    catUser: {
      type: Boolean,
      default: false,
    },
    current: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      if (this.mode === 'ADD') return '新增管控任务';
      if (this.mode === 'DETAILS') {
        if (this.catUser) return '应用成员';
        return '查看管控任务';
      }

      if (this.mode === 'SUBSCRIBE') return '订阅管控任务';
      if (this.mode === 'DETAILS' && this.catUser) return '应用成员';
      return '编辑管控任务';
    },
  },
  methods: {
    handleClose(val) {
      if (val === 'ok') {
        this.$emit('ok');
      }
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialogPopRule ::v-deep .el-dialog {
  top: 5vh !important;
  transform: translateY(0) !important;
  margin-top: 0 !important;
}
</style>
